import {
  BlogPosting,
  Event,
  ImageObject,
  LiveBlogPosting,
  Organization,
  Person,
  Place,
  SportsEvent,
  SportsTeam,
  VirtualLocation,
} from "schema-dts";

export const createImageObject = ({ url, width, height }: { url: URL; width: number; height: number }): ImageObject => {
  return {
    "@type": "ImageObject",
    url: url.toString(),
    width: width.toString(),
    height: height.toString(),
  };
};

export const createPerson = ({ name, url }: { name: string; url: URL }): Person => {
  return {
    "@type": "Person",
    name,
    url: url.toString(),
  };
};

export const createOrganization = ({ name, logo }: { name: string; logo: ImageObject }): Organization => {
  return {
    "@type": "Organization",
    name,
    logo,
  };
};

export const createVirtualLocation = ({ url }: { url: URL }): VirtualLocation => {
  return {
    "@type": "VirtualLocation",
    url: url.toString(),
  };
};

export const createPlace = ({ name }: { name: string }): Place => {
  return {
    "@type": "Place",
    name,
  };
};

export const createSportsTeam = ({ name }: { name: string }): SportsTeam => {
  return {
    "@type": "SportsTeam",
    name,
  };
};

export const createEvent = ({
  name,
  startDate,
  endDate,
  location,
}: {
  name: string;
  startDate: Date;
  endDate?: Date;
  location: VirtualLocation;
}): Event => {
  return {
    "@type": "Event",
    name,
    startDate: startDate.toISOString(),
    ...(endDate && { endDate: endDate.toISOString() }),
    eventAttendanceMode: "https://schema.org/OnlineEventAttendanceMode",
    location,
  };
};

export const createSportsEvent = ({
  name,
  startDate,
  endDate,
  location,
  homeTeam,
  awayTeam,
}: {
  name: string;
  startDate: Date;
  endDate?: Date;
  location: Place;
  homeTeam: SportsTeam;
  awayTeam: SportsTeam;
}): SportsEvent => {
  return {
    "@type": "SportsEvent",
    name,
    startDate: startDate.toISOString(),
    ...(endDate && { endDate: endDate.toISOString() }),
    location,
    homeTeam,
    awayTeam,
  };
};

export const createBlogPosting = ({
  datePublished,
  articleBody,
}: {
  datePublished: Date;
  articleBody: string;
}): BlogPosting => {
  return {
    "@type": "BlogPosting",
    datePublished: datePublished.toISOString(),
    articleBody,
  };
};

export const createLiveBlogPosting = ({
  name,
  headline,
  description,
  url,
  mainEntityOfPage,
  coverageStartTime,
  coverageEndTime,
  datePublished,
  dateModified,
  image,
  author,
  about,
  publisher,
  liveBlogUpdate,
}: {
  name: string;
  headline: string;
  description: string;
  url: URL;
  mainEntityOfPage: URL;
  coverageStartTime: Date;
  coverageEndTime?: Date;
  datePublished: Date;
  dateModified?: Date;
  image: ImageObject;
  author: Person[];
  about: Event | SportsEvent;
  publisher: Organization;
  liveBlogUpdate: BlogPosting[];
}): LiveBlogPosting => {
  return {
    "@type": "LiveBlogPosting",
    name,
    headline,
    description,
    url: url.toString(),
    mainEntityOfPage: mainEntityOfPage.toString(),
    coverageStartTime: coverageStartTime.toISOString(),
    ...(coverageEndTime && { coverageEndTime: coverageEndTime.toISOString() }),
    datePublished: datePublished.toISOString(),
    ...(dateModified && { dateModified: dateModified.toISOString() }),
    image,
    author,
    about,
    publisher,
    liveBlogUpdate,
  };
};
